// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiffOutlinedSvg from "@fishx/icons-svg/es/asn/DiffOutlined";
import FishxIcon from '../components/FishxIcon';

var DiffOutlined = function DiffOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DiffOutlinedSvg
  }));
};

DiffOutlined.displayName = 'DiffOutlined';
export default React.forwardRef(DiffOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DiffOutlined.js
// module id = 2416
// module chunks = 0